import { Navigate, useLocation } from "react-router"

export default function RedirectSignupsToEvents() {
  const { search, pathname } = useLocation()
  const redirectedPathname = pathname.replace("/signups", "/events")
  const redirectUrl = `${redirectedPathname}${search}`
  return <Navigate to={redirectUrl} replace />
}
